module.exports = __webpack_public_path__ + "img/trash-light-green.f27ed677.png";